import { Component, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LanguageManagementService } from '../../../service/language-management.service';
import { CommunicationTemplate, InteractionType, KeyValues5, LocalService, PageKey, Wrapper10Initialization } from '../../../service/local.service';
import { TaskManagementService } from 'src/service/task-management.service';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';

@Component({
  selector: 'app-task-requests',
  templateUrl: './task-requests.component.html',
  styleUrl: './task-requests.component.scss'
})
export class TaskRequestsComponent {
  lstSectionConfigKeys: string[] = ["tasks", "table"]; CommunicationTemplate = CommunicationTemplate;
  userId: string = ''; ctryCode: string = ''; interactionType = InteractionType.None; maxBodyHeight = 0;

  wrapper: Wrapper10Initialization; isParentTaskAvailable: boolean = false; isRestricted: boolean = true;

  isTaskRequestPopupOpen: boolean = false; selectedTaskId: string = ''; parentTaskNumber: string = ''; isOpenSendToPhone = false;
  selectedTaskOwner: string = ''; selectedTaskType: string = ''; selectedTaskStatus: string = '';
  selectedTaskOwnerChild: string = ''; selectedTaskTypeChild: string = ''; selectedTaskStatusChild: string = '';

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private route: ActivatedRoute, private taskManagementService: TaskManagementService, private languageManagementService: LanguageManagementService, private router: Router, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = parseInt(routeParams.interactionType);
      this.userId = routeParams.userId;
      this.ctryCode = routeParams.ctryCode;
      this.parentTaskNumber = routeParams.parentTaskNumber && routeParams.parentTaskNumber.length > 3 ? routeParams.parentTaskNumber : '';
      this.configurationManagementService.ensurePageActions(this.interactionType == InteractionType.Bill_PnixSoft ? PageKey.TaskRequestsAdmin : PageKey.TaskRequests);
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
      this.onInitiate();
    });
  }

  ngAfterViewChecked() {
    setTimeout(() => {
      this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
      this.cdr.detectChanges();
    }, 500);
  }

  onInitiate() {
    this.selectedTaskOwner = '';
    this.selectedTaskOwnerChild = '';
    this.isParentTaskAvailable = this.parentTaskNumber && this.parentTaskNumber.length > 3 ? true : false;
    this.isRestricted = this.interactionType != InteractionType.Bill_PnixSoft;
    // if (this.isRestricted) {
    //   this.selectedTaskOwner = this.userId;
    // }
    this.onLoad();
  }

  onLoad() {
    this.onGetTaskOwners();
  }

  isLoading = false;
  onGetTaskOwners() {
    if (!this.isLoading) {
      this.isLoading = true;
      if (!this.wrapper) {
        this.taskManagementService.getTaskRequestsInitialization(this.onGetFilterData()).subscribe(result => {
          this.wrapper = result;
          this.onSetTitles();
          this.isLoading = false;
          this.ngAfterViewChecked();
        });
      } else {
        this.taskManagementService.getTaskRequests(this.onGetFilterData(), this.wrapper.content.paging).subscribe(result => {
          this.wrapper.content = result;
          this.onSetTitles();
          this.isLoading = false;
        });
      }
    }
  }

  onGetFilterData(): KeyValues5 {
    return {
      v1: this.parentTaskNumber,
      v2: this.isParentTaskAvailable ? this.selectedTaskOwnerChild : this.selectedTaskOwner,
      v3: this.isParentTaskAvailable ? this.selectedTaskTypeChild : this.selectedTaskType,
      v4: this.isParentTaskAvailable ? this.selectedTaskStatusChild : this.selectedTaskStatus,
    } as KeyValues5;
  }

  onSetTitles() {
    this.wrapper.content.items.forEach(item => {
      item.v4 = this.localService.getText(this.wrapper.configs_1, item.v4);
      item.v5 = this.localService.getText(this.wrapper.configs_2, item.v5);
    });
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        this.selectedTaskId = '';
        this.isTaskRequestPopupOpen = true;
      } break;
      case 2: {
        this.selectedTaskId = key;
        this.isTaskRequestPopupOpen = true;
      } break;
      case 3: {
        this.selectedTaskId = key;
        this.isOpenSendToPhone = true;
      } break;
      case 4: {
        const item = this.wrapper.content.items.find(x => x.key == key);
        if (item) {
          this.router.navigate(['/task-requests' + this.localService.basicParamsString, item.v7]);
        }
      } break;
      case 5: {
        this.router.navigate(['/task-requests' + this.localService.basicParamsString, 0]);
      } break;
      case 6: {
        //Clone
      } break;
      case 7: {
        this.onSendTaskRequestAlerts();
      } break;
    }
  }

  onSendTaskRequestAlerts() {
    this.taskManagementService.sendTaskRequestAlerts().subscribe(result => {
      this.localService.showInformationByStatus(result.status);
    });
  }
}
